exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#forgot-password-page .el-avatar-loading[data-v-29379521], #forgot-password-page .el-avatar-loading img[data-v-29379521] {\n  width: 100%;\n}", ""]);

// exports
